import IdentityPageLayout from "@/features/identity/components/IdentityPageLayout.tsx";
import RegistrationConfirmForm from '@/features/identity/components/RegistrationConfirmForm';

const RegistrationConfirmPage = () => {
    return (
        <IdentityPageLayout>
            <RegistrationConfirmForm />
        </IdentityPageLayout>
    );
};

export default RegistrationConfirmPage;
